import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../components/public/PublicLayout';
import { Megaphone, Users, BookOpen, FileText } from 'lucide-react';

const AdvocacyAwarenessPage = () => {
  return (
    <PublicLayout>
      <div className="py-5" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)' }}>
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                style={{ width: '80px', height: '80px', backgroundColor: '#6B8E23' }}>
                <Megaphone className="text-white" size={40} />
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Advocacy & Awareness</h1>
              <p className="lead text-muted">
                Raising awareness and advocating for better respiratory healthcare policies across Africa
              </p>
            </div>
          </div>

          {/* Main Content */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <div className="card shadow border-0">
                <div className="card-body p-4 p-lg-5">
                  <h2 className="h3 fw-bold text-dark mb-4">Our Advocacy Work</h2>
                  <p className="text-muted mb-4">
                    ARCA is committed to advocating for improved respiratory care policies, increased funding for
                    respiratory health programs, and better access to respiratory care services across Africa. We work
                    with governments, healthcare organizations, and international partners to drive positive change.
                  </p>

                  <h3 className="h4 fw-bold text-dark mb-3">Key Focus Areas</h3>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Policy Development:</strong> Working with governments to develop and implement
                      respiratory care policies and guidelines
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Public Awareness Campaigns:</strong> Educating communities about respiratory
                      health and disease prevention
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Healthcare Advocacy:</strong> Promoting the role of respiratory care professionals
                      in healthcare systems
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Resource Mobilization:</strong> Advocating for increased funding and resources
                      for respiratory care programs
                    </li>
                  </ul>

                  <div className="alert" style={{ backgroundColor: '#e8f5e9', borderColor: '#6B8E23', color: '#2c5014' }}>
                    <strong>Coming Soon:</strong> Detailed information about our advocacy campaigns,
                    policy briefs, and how you can get involved in our advocacy efforts.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Get Involved Section */}
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <Users className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Join Our Advocacy Network</h5>
                  <p className="text-muted mb-3">Connect with advocates across Africa</p>
                  <Link to="/get-involved/volunteer" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>Join Now</Link>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <FileText className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Read Our Policy Briefs</h5>
                  <p className="text-muted mb-3">Access our latest policy documents</p>
                  <Link to="/resources/policy-documents" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>View Documents</Link>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <BookOpen className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Learn More</h5>
                  <p className="text-muted mb-3">Discover our resources and publications</p>
                  <Link to="/resources/publications" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>Explore Resources</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default AdvocacyAwarenessPage;
